import controller_0 from '@symfony/ux-autocomplete/dist/controller.js';
import 'tom-select/dist/css/tom-select.bootstrap5.css';
import controller_1 from '@symfony/ux-turbo/dist/turbo_controller.js';
export default {
  'symfony--ux-autocomplete--autocomplete': controller_0,
  'symfony--ux-turbo--turbo-core': controller_1,
};